import { render, staticRenderFns } from "./OnboardingRequirementsTab.vue?vue&type=template&id=0f397e8f&"
import script from "./OnboardingRequirementsTab.vue?vue&type=script&lang=js&"
export * from "./OnboardingRequirementsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports